<template>
  <el-dialog :title="title" align="center" :visible="visible" width="30%" @close="handleClose">
    <el-form label-width="40px" :model="editForm" ref="editForm">
      <el-row>
        <el-form-item label="应收" prop="receivable">
          <el-input
              size="small"
              v-model="editForm.receivable"
              auto-complete="off"
              placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="应付" prop="cope">
          <el-input
              size="small"
              v-model="editForm.cope"
              auto-complete="off"
              placeholder=""
          ></el-input>
        </el-form-item>
      </el-row>
     <el-row>
        <el-form-item label="备注" prop="remark">
          <el-input
              type="textarea"
              size="small"
              v-model="editForm.remark"
              auto-complete="off"
              placeholder="备注"
          ></el-input>
        </el-form-item>
      </el-row> 

      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { edit  } from "@/api/ticket/trad";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleSubmit() {
      edit(this.editForm)
            .then(() => {
              this.$message({
                message: `${this.editForm.id ? "编辑" : "保存"}成功`,
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });

    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-transaction/edit.vue